import React, { useEffect, useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Notice } from '../../components/ui/Notice';
import { Table, Tr, Td } from '../../components/ui/Table';
import { getMarkupRules, createMarkupRule, updateMarkupRule } from '../../api/pricing';
import { MarkupRule } from '../../types';

export const MarkupRules: React.FC = () => {
  const [rules, setRules] = useState<MarkupRule[]>([]);
  const [editId, setEditId] = useState<string | null>(null);
  const [markup, setMarkup] = useState('10');
  const [roundingUnit, setRoundingUnit] = useState('1000');
  const [msg, setMsg] = useState('');

  const load = () => getMarkupRules().then(r => setRules(r.data.results || r.data));
  useEffect(() => { load(); }, []);

  const handleSave = async () => {
    try {
      if (editId) {
        await updateMarkupRule(editId, { markup_percent: markup, rounding_unit: parseInt(roundingUnit) });
      } else {
        await createMarkupRule({ markup_percent: markup, rounding_unit: parseInt(roundingUnit) });
      }
      setMsg('Tersimpan!'); load(); setEditId(null);
      setTimeout(() => setMsg(''), 3000);
    } catch (e: any) {
      setMsg(e.response?.data?.markup_percent?.[0] || 'Gagal menyimpan');
    }
  };

  return (
    <div>
      <h1 style={{ fontSize: 20, fontWeight: 500, marginBottom: 20 }}>Markup Rules</h1>
      <Notice type="warn">Markup dihitung di atas harga kontrak. Tidak bisa input harga manual — semua dihitung otomatis oleh sistem.</Notice>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 340px', gap: 16 }}>
        <Card title="Markup rules aktif">
          <Table headers={['User', 'Hotel', 'Markup %', 'Rounding', 'Status']}>
            {rules.map(r => (
              <Tr key={r.id}>
                <Td style={{ fontWeight: 500 }}>{r.user_name}</Td>
                <Td style={{ fontSize: 12 }}>{r.hotel || 'Semua hotel'}</Td>
                <Td><span style={{ fontFamily: 'monospace', fontWeight: 500 }}>{r.markup_percent}%</span></Td>
                <Td style={{ fontSize: 12 }}>Kelipatan {r.rounding_unit}</Td>
                <Td>
                  <button onClick={() => { setEditId(r.id); setMarkup(r.markup_percent); setRoundingUnit(String(r.rounding_unit)); }}
                    style={{ padding: '3px 10px', border: '0.5px solid rgba(0,0,0,0.15)', background: 'transparent', borderRadius: 6, fontSize: 11, cursor: 'pointer' }}>
                    Edit
                  </button>
                </Td>
              </Tr>
            ))}
          </Table>
        </Card>
        <Card title={editId ? 'Edit rule' : 'Tambah rule baru'}>
          {msg && <Notice type={msg === 'Tersimpan!' ? 'success' : 'danger'}>{msg}</Notice>}
          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 500, marginBottom: 6 }}>Markup (%)</label>
            <input type="number" value={markup} onChange={e => setMarkup(e.target.value)} min="0" max="100" step="0.5"
              style={{ width: '100%', padding: '8px 10px', border: '0.5px solid rgba(0,0,0,0.2)', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }} />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 500, marginBottom: 6 }}>Rounding unit</label>
            <select value={roundingUnit} onChange={e => setRoundingUnit(e.target.value)}
              style={{ width: '100%', padding: '8px 10px', border: '0.5px solid rgba(0,0,0,0.2)', borderRadius: 8, fontSize: 13, background: '#fafaf9' }}>
              <option value="1000">Rp 1.000</option>
              <option value="5000">Rp 5.000</option>
              <option value="10000">Rp 10.000</option>
              <option value="50000">Rp 50.000</option>
            </select>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={handleSave}
              style={{ padding: '8px 16px', background: '#0F6E56', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 500, cursor: 'pointer' }}>
              Simpan
            </button>
            {editId && <button onClick={() => setEditId(null)}
              style={{ padding: '8px 14px', border: '0.5px solid rgba(0,0,0,0.15)', background: 'transparent', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>
              Batal
            </button>}
          </div>
        </Card>
      </div>
    </div>
  );
};
